import { render, staticRenderFns } from "./guanxi-tree.vue?vue&type=template&id=b3116282&scoped=true&"
import script from "./guanxi-tree.vue?vue&type=script&lang=ts&"
export * from "./guanxi-tree.vue?vue&type=script&lang=ts&"
import style0 from "./guanxi-tree.vue?vue&type=style&index=0&id=b3116282&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3116282",
  null
  
)

export default component.exports